import BusinessModel from "../components/Business Model/BusinessModel";

export default {
    name: "BusinessModel",
    component: BusinessModel,
    url: "/business-model",
    exact: true,
    requireAuth: true
};